<template>
  <div :style="{ paddingBottom: nativeHeaderHeight + 'px' }">
    <div
      class="app-header"
      :class="{ transparent: transparent, transparentBlack: transparentBlack }"
      :style="{
        backgroundColor: transparent ? backgroundColor + ' !important' || 'transparent !important' : null,
        color: color
      }"
    >
      <div class="status-bar" :style="{ height: statusBarHeight + 'px' }"></div>
      <mt-header v-if="header" :title="title" ref="appheader">
        <!-- <router-link :to="to" slot="left">
        <mt-button icon="back"></mt-button>
      </router-link> -->
        <mt-button v-if="leftIcon" slot="left" @click="leftEvent" :style="leftStyle">
          <iconfont :class="leftIcon" />
        </mt-button>
        <!-- 内置右侧按钮 -->
        <mt-button v-if="rightIcon" slot="right" @click="itemAction">
          <iconfont :class="rightIcon" />
        </mt-button>
        <!-- 根据needRight来确定右侧是否需要slot 例:<div name="right">icon</div> -->
        <template v-if="needRight">
          <slot slot="right" />
        </template>
        <!-- 自定义右侧区域, 项目内没找到用例 -->
        <template v-else>
          <span slot="right">
            <slot name="right" />
          </span>
        </template>
      </mt-header>
    </div>
  </div>
</template>

<script>
import { MessageBox, Toast } from 'mint-ui'
import { hasHeader } from './index'
import { appUser } from '@/utils'
// 原生方法退出页面
import { $backToAppCallBack } from '@/utils/common/native-api'

export default {
  name: 'AppHeader',
  props: {
    title: String,
    backType: {
      type: String,
      default: ''
    },
    needConfirm: {
      type: String,
      default: ''
    },
    needRight: Boolean, // 右上角图标
    bgcolor: String, // 自定义导航条背景颜色
    color: String,
    leftName: String, // 左上角图标
    leftStyle: String,
    actionIcon: String, // 事件的图标
    actionName: String, // 页面的右上角事件
    actionConfirm: Object, // 事件确认对象
    to: {
      type: Object,
      default: () => {}
    },
    transparent: Boolean, // 透明操作
    transparentBlack: Boolean
  },
  data() {
    const header = hasHeader()
    const statusBarHeight = parseInt(appUser.appStatusBarHeight || 0)
    const nativeHeaderHeight = parseInt(appUser.appStatusBarHeight || 0) + 44
    return {
      statusBarHeight: header ? statusBarHeight : 0,
      nativeHeaderHeight: header ? nativeHeaderHeight : 0,
      header
    }
  },
  computed: {
    backIcon() {
      return 'iconback'
    },
    leftIcon() {
      let icon = this.leftName
      if (icon) {
        icon = 'icon' + this.leftName
      } else {
        icon = this.backIcon
      }
      return icon
    },
    rightIcon() {
      let icon = this.actionIcon
      if (icon == null && this.actionName) {
        icon = 'icon' + this.actionName
      }
      return icon
    },
    // 取自应用的背景
    backgroundColor() {
      if (this.bgcolor) {
        return this.bgcolor
      }
      const [{ backgroundColor: bgcolor }] = this.$root.$children // App
      return bgcolor
    }
  },
  created() {},
  methods: {
    goBack() {
      this.$router.back()
      // if (!this.needConfirm) {
      //   this.$router.back()
      // } else {
      //   console.log('goBack handle')
      //   MessageBox.confirm('是否放弃本次付款', {
      //     cancelButtonText: '放弃',
      //     confirmButtonText: '继续支付'
      //   }).then(action => {
      //
      //   }).catch(action => {
      //     this.$router.back()
      //   });
      // }
    },
    leftEvent() {
      const { backType } = this
      // 有支付导购页面
      if (this.$route.query.paytype) {
        this.goBack()
        return
      }

      console.log({ message: 'backType: ' + (backType || 'go(-1)') })

      if (backType === 'event') {
        this.$emit('left-event')
      } else if (backType === 'back-app') {
        // 判断原生app内和浏览器环境
        if (appUser.isNative) $backToAppCallBack()
        else this.goBack()
      } else {
        this.goBack()
      }
    },
    toast(message) {
      Toast({ message })
    },
    itemAction() {
      const confirm = this.actionConfirm
      if (confirm) {
        const { message } = confirm
        MessageBox.confirm(message)
          .then(action => {
            this.$emit('action')
          })
          .catch(_ => {})
      } else {
        this.$emit('action')
      }
    }
  }
}
</script>

<style lang="scss">
.app-header {
  position: fixed;
  z-index: 9999;
  width: 100%;
  background-color: #ffffffff !important;
  //top:0;
  .mint-header {
    width: 100%;
    height: 44px;
    // border-bottom: 1px solid #dddddd;
    background-color: #ffffffff !important;
    color: #2c3e50;
    font-size: 16px;
    padding: 20px 16px;
    .mint-header-title {
      font-weight: bold;
      font-size: 18px;
      flex: none;
    }
  }
  // 透明菜单
  &.transparent {
    background: transparent !important;
    .mint-header {
      background-color: transparent !important;
      border-width: 0;
      color: white;
    }
  }
  &.transparentBlack {
    background: transparent !important;
    .mint-header {
      background-color: transparent !important;
      border-width: 0;
      color: #000;
    }
  }
  // 图标
  .iconfont {
    font-size: 24px;
  }
}
</style>
